






















import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
@Component({})
export default class AccountLoginCmp extends Vue {
  private info: any = {
    用户名: "",
    密码: ""
  };
  private rules: any = {
    用户名: [{ required: true, message: "用户名必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }]
  };
  /**
   * @description 登录
   */
  private login() {
    (this.$refs.loginForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = {
          用户名: this.info["用户名"],
          密码: this.info["密码"]
        };
        this.$store
          .dispatch("login", params)
          .then(() => {
            this.$router.push("/main/system/role");
          })
          .catch((error: string) => {
            console.log(error);
            this.$message.error(error);
          });
      }
    });
  }
  /**
   * @description 跳转忘记密码
   */
  private jumpForgot() {
    this.$router.push("/access/forgot");
  }
}
